import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./layout/AppShell";
import { ActivitiesPage } from "./pages/ActivitiesPage";
import { ActivityLogPage } from "./pages/ActivityLogPage";
import { AddPatientPage } from "./pages/AddPatientPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { CalendarPage } from "./pages/CalendarPage";
import { CampaignEditPage } from "./pages/CampaignEditPage";
import { CampaignsPage } from "./pages/CampaignsPage";
import { CommunicationsPage } from "./pages/CommunicationsPage";
import { ComposePage } from "./pages/ComposePage";
import {
  FormDetailPage,
  FormEditTab,
  FormPreviewTab,
  FormResponsesTab,
  FormSettingsTab,
} from "./pages/FormDetailPage";
import { FormsPage } from "./pages/FormsPage";
import { MessagesPage } from "./pages/MessagesPage";
import { PatientLayout } from "./pages/PatientLayout";
import {
  PatientActivityTab,
  PatientAppointmentsTab,
  PatientConversationTab,
  PatientDocumentsTab,
  PatientMedicationsTab,
  PatientPaymentsTab,
} from "./pages/PatientTabs";
import { PatientsPage } from "./pages/PatientsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { SurveyDetailPage } from "./pages/SurveyDetailPage";
import { SurveysPage } from "./pages/SurveysPage";
import { TeamPage } from "./pages/TeamPage";
import { TeamProviderPage } from "./pages/TeamProviderPage";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app/activities" replace />} />
      <Route path="/app" element={<AppShell />}>
        <Route index element={<Navigate to="activities" replace />} />
        <Route path="activities" element={<ActivitiesPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="compose" element={<ComposePage />} />
        <Route path="patients" element={<PatientsPage />} />
        <Route path="add-patient" element={<AddPatientPage />} />
        <Route path="patients/:id" element={<PatientLayout />}>
          <Route index element={<Navigate to="activity" replace />} />
          <Route path="activity" element={<PatientActivityTab />} />
          <Route path="appointments" element={<PatientAppointmentsTab />} />
          <Route path="payments" element={<PatientPaymentsTab />} />
          <Route
            path="conversations/:conversationId"
            element={<PatientConversationTab />}
          />
          <Route path="medication" element={<PatientMedicationsTab />} />
          <Route path="documents" element={<PatientDocumentsTab />} />
        </Route>
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="team/:id/*" element={<TeamProviderPage />} />
        <Route path="communications" element={<CommunicationsPage />} />
        <Route
          path="communications/activity-log"
          element={<ActivityLogPage />}
        />
        <Route path="campaigns" element={<CampaignsPage />} />
        <Route path="campaigns/:id/edit/*" element={<CampaignEditPage />} />
        <Route path="surveys" element={<SurveysPage />} />
        <Route path="surveys/:id" element={<SurveyDetailPage />} />
        <Route path="forms" element={<FormsPage />} />
        <Route path="forms/:id" element={<FormDetailPage />}>
          <Route index element={<Navigate to="edit" replace />} />
          <Route path="main" element={<FormSettingsTab />} />
          <Route path="edit" element={<FormEditTab />} />
          <Route path="preview" element={<FormPreviewTab />} />
          <Route path="responses" element={<FormResponsesTab />} />
        </Route>
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="settings/*" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/app/activities" replace />} />
    </Routes>
  );
}
